import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import Typography from "../Typography/Typography";
import Button from "../Button/Button";
import Checkbox from "../Checkbox/Checkbox";
import {READER_PLAYER_BEHAVIOURS} from "../../utils/reader/constants";
import {getPlayerBehaviorLabel} from "../../utils/reader/reader";

import styles from "./PlayerBehaviourDialog.module.scss";

const PlayerBehaviourDialog = ({
  subtitle,
  canPlayFromCurrentPara,
  canPlayFirstAvailable,
  canPlayFromHistory,
  canContinue,
  canDoNotAskAgain,
  isDoNotAskChecked,
  onClickBehaviour,
}) => {
  const { t } = useSharedTranslation();
  const [doNotAskAgain, setDoNotAskAgain] = useState(isDoNotAskChecked);

  const handleChooseBehaviour = (type) => {
    onClickBehaviour(type, doNotAskAgain);
  };

  return (
    <div className={styles["dialog-player-behaviour"]}>
      <Typography variant="h3">{t("playerBehaviour")}</Typography>
      {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      <div className={styles["dialog-player-behaviour__buttons"]}>
        {
          canPlayFromCurrentPara &&
          <Button
            onClick={() => {
              handleChooseBehaviour(READER_PLAYER_BEHAVIOURS.CURRENT_PARA);
            }}
            className="dialog-btn">
            {t(getPlayerBehaviorLabel((READER_PLAYER_BEHAVIOURS.CURRENT_PARA)))}
          </Button>
        }

        {
          canPlayFirstAvailable &&
          <Button
            onClick={() => {
              handleChooseBehaviour(READER_PLAYER_BEHAVIOURS.FIRST_AVAILABLE);
            }}
            className={styles["btn"]}>
            {t(getPlayerBehaviorLabel(READER_PLAYER_BEHAVIOURS.FIRST_AVAILABLE))}
          </Button>
        }

        {
          canPlayFromHistory &&
          <Button
            onClick={() => {
              handleChooseBehaviour(READER_PLAYER_BEHAVIOURS.HISTORY);
            }}
            className={styles["btn"]}>
            {t(getPlayerBehaviorLabel(READER_PLAYER_BEHAVIOURS.HISTORY))}
          </Button>
        }

        {
          canContinue && (canPlayFromHistory || canPlayFirstAvailable || canPlayFromCurrentPara)
          && <div>{t("OR")}</div>
        }

        {
          canContinue && <Button
            onClick={() => {
              handleChooseBehaviour(READER_PLAYER_BEHAVIOURS.CONTINUE);
            }}
            className={styles["btn"]}>
            {t("continuePlaying")}
          </Button>
        }
      </div>
      {
        canDoNotAskAgain && (
          <div>
            <Checkbox
              className={styles["dialog-player-behaviour__checkbox"]}
              title={t("doNotAskAgain")}
              checked={doNotAskAgain}
              onChange={() => {
                setDoNotAskAgain(!doNotAskAgain);
              }}
            />
          </div>
        )
      }
    </div>
  );
};

PlayerBehaviourDialog.propTypes = {
  subtitle: PropTypes.string,
  canPlayFromCurrentPara: PropTypes.bool,
  canPlayFirstAvailable: PropTypes.bool,
  canPlayFromHistory: PropTypes.bool,
  canContinue: PropTypes.bool,
  canDoNotAskAgain: PropTypes.bool,
  isDoNotAskChecked: PropTypes.bool,
  onClickBehaviour: PropTypes.func,
};

export default PlayerBehaviourDialog;
